import { Box, Link } from '@bcp-nextgen-dx-component-factory/design-system';
import { NavRight } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';

import { AppComposableTypography } from '../_cf';
import { LanguageSelection } from '../languageSelection';
import { Divider } from './divider';
import { FooterProps } from './footer';
import { resources, useFooterHelper } from './footer.helper';

export const FooterMobile = ({ styles }: FooterProps) => {
	const { t, translationKey, showText, showLink } = useFooterHelper();

	return (
		<>
			<Divider />
			<Box
				styles={{
					flexDirection: 'column',
					alignItems: 'center',
					background: '#FFFFFF',
					padding: UIHelper.rem(30, 24),
					gap: UIHelper.rem(24),
					...styles,
				}}
			>
				{(showText || showLink) && (
					<Box
						styles={{
							justifyContent: 'center',
							textAlign: 'center',
							gap: UIHelper.rem(8),
							flexWrap: 'wrap',
						}}
					>
						{showText && (
							<AppComposableTypography
								appearance="body-75-02"
								colorToken="secondary-light"
								text={t(resources[translationKey].text)}
							/>
						)}

						{showLink && (
							<Link
								label={t(resources[translationKey].link.text)}
								link={t(resources[translationKey].link.url)}
								rightIcon={NavRight.Outline}
								target="_blank"
								size="medium"
							/>
						)}
					</Box>
				)}

				<LanguageSelection size="small" />
			</Box>
		</>
	);
};
